{
  "en": {
    "dashboard": {
      "showAll": "Show all",
      "empty": "Nothing here yet.",
      "failed": "This could not be loaded right now."
    }
  }
}
